import React from 'react';
import ReactDom from 'react-dom';
import { findOrCreateElement } from './findOrCreateElement';

export const Portal: React.FC<React.PropsWithChildren<{ rootId?: string }>> = ({ rootId = 'shef-modal', children }) => {
  const root = findOrCreateElement(rootId);

  return ReactDom.createPortal(children, root);
};
